import React from 'react';
import cx from 'classnames';
import Img from '../../../../../../components/Img';
import { WIDGET_BANNER_SECTION_LAYOUT_INFO } from '../../../../../../constants/service/app/widgetConstants';
import './WidgetPreviewBannerGridLayout.scss';

const WidgetPreviewBannerGridLayout = (props) => {
  const { list, layoutType } = props;

  return (
    <div
      className={cx(
        'widget-banner-grid-layout',
        `col-${WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].NUMBER_OF_COLUMN_COUNT}`,
      )}
    >
      {list.map((eventSection, index) => (
        <div key={index} className="widget-banner-section">
          <Img clickAble={false} src={eventSection.url} />
        </div>
      ))}
    </div>
  );
};

export default WidgetPreviewBannerGridLayout;
